export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/a70fe28c30edbe909cade8425716fdee.svg";